import React from 'react';

import styled from '@emotion/styled';
import { PillBadge } from '@lightspeed/flame/Badge';

import { NOTIFICATION_STYLE_COLORS, NOTIFICATION_STYLES, NotificationStyle } from './utils';

const StyledPillBadge = styled(PillBadge)<{
  bgColor: string;
  borderColor: string;
  textColor: string;
}>`
  font-size: 0.65rem;
  height: 20px;
  background-color: ${(props) => props.bgColor};
  border: 1px solid ${(props) => props.borderColor};
  color: ${(props) => props.textColor};
  padding-left: 10px;
  padding-right: 10px;
  letter-spacing: normal;
`;

type NotificationBadgeProps = {
  count: number;
  style?: NotificationStyle;
  className?: string;
  badgeStyle?: React.CSSProperties;
  'data-test'?: string;
};

/**
 * Reusable notification badge component with style variants.
 * Used by TileNotificationCount, TabNotification, and Sidebar.
 */
export const NotificationBadge = ({
  count,
  style = NOTIFICATION_STYLES.DANGER,
  className,
  badgeStyle,
  'data-test': dataTest,
}: NotificationBadgeProps) => {
  const colors = NOTIFICATION_STYLE_COLORS[style];

  return (
    <StyledPillBadge
      bgColor={colors.background}
      borderColor={colors.border}
      textColor={colors.text}
      className={className}
      style={badgeStyle}
      data-test={dataTest}
    >
      {count}
    </StyledPillBadge>
  );
};
